import { render, staticRenderFns } from "./EmailVerifiedPage.vue?vue&type=template&id=655ee77e"
import script from "./EmailVerifiedPage.vue?vue&type=script&lang=js"
export * from "./EmailVerifiedPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports